import { Icon } from "components/Icon";
import type React from "react";
import { useState } from "react";
import type { CollapsibleProps } from "./Collapsible.model";
import {
  StyledContainerCollapsible,
  StyledContent,
  StyledExtraComponent,
  StyledHeader,
  StyledIcon,
  StyledTitle,
} from "./Collapsible.styled";

export const Collapsible: React.FC<CollapsibleProps> = ({ title, headerComponent, children }) => {
  const [isCollapsed, toggleCollapsible] = useState(false);

  return (
    <StyledContainerCollapsible>
      <StyledHeader onClick={() => toggleCollapsible(!isCollapsed)}>
        <StyledTitle>{title}</StyledTitle>
        <StyledExtraComponent>
          {headerComponent}
          <StyledIcon>
            <Icon className={isCollapsed ? "icon-arrow_thick_down" : "icon-arrow_thick_up"} />
          </StyledIcon>
        </StyledExtraComponent>
      </StyledHeader>
      <StyledContent isCollapsed={isCollapsed}>{children}</StyledContent>
    </StyledContainerCollapsible>
  );
};
